import { useMemo } from 'react'

import { TableDataQa } from 'commons/types/enums'
import { DataSourceItem, SortDirection, Table as TableUI } from 'ui/components'
import { BankUsersReportItem } from '~bank-reports/types/BankUsersReport'

import { useUserReportContext } from '../../context/UserReportContext'
import { columns } from './columns'

export const Table = () => {
  const { data, state, navigate, isPending } = useUserReportContext()

  const mappedItems: DataSourceItem<BankUsersReportItem>[] = useMemo(
    () =>
      data?.items?.map((el) => ({
        item: el
      })),
    [data?.items]
  )

  return (
    <TableUI
      dataQa={TableDataQa.BP_REPORTS_USERS_REPORT}
      columns={columns(data?.availableSortFields)}
      loading={isPending}
      dataSource={mappedItems}
      sorting={{
        order: [
          {
            field: state?.sortBy || '',
            direction: state.sortDesc ? 'DESC' : 'ASC'
          }
        ],
        onChange: (sorting) => {
          navigate({ sortBy: sorting.field, sortDesc: sorting.direction === SortDirection.DESC })
        }
      }}
      pagination={{
        page: state.page,
        size: state.size,
        onChange: (page, size) => {
          navigate({ page, size })
        },
        total: data?.total
      }}
    />
  )
}
